export default __webpack_public_path__ + "static/media/no-video-cover.32ed8b6a.svg";